/**
 * Template Registry
 *
 * This module manages template-specific components and mappers for PDFViewerV2.
 */

import { PdfConfig as PdfConfig_68ef31e18875863b2fa59822 } from './68ef31e18875863b2fa59822/PdfConfig';
import { FactsheetPreview as FactsheetPreview_68ef31e18875863b2fa59822 } from './68ef31e18875863b2fa59822/PdfPreview';
import { PdfPreviewDialog as PdfPreviewDialog_68ef31e18875863b2fa59822, FactsheetPDF as FactsheetPDF_68ef31e18875863b2fa59822 } from './68ef31e18875863b2fa59822/PdfPreviewDialog';
import { mapV1FieldsToV2Data as mapV1FieldsToV2Data_68ef31e18875863b2fa59822, buildCustomizePayload as buildCustomizePayload_68ef31e18875863b2fa59822 } from './68ef31e18875863b2fa59822/mappers';

import { PdfConfig as PdfConfig_691f80ce0664e043e4a1986d } from './691f80ce0664e043e4a1986d/PdfConfig';
import { FactsheetPreview as FactsheetPreview_691f80ce0664e043e4a1986d } from './691f80ce0664e043e4a1986d/PdfPreview';
import { PdfPreviewDialog as PdfPreviewDialog_691f80ce0664e043e4a1986d, FactsheetPDF as FactsheetPDF_691f80ce0664e043e4a1986d } from './691f80ce0664e043e4a1986d/PdfPreviewDialog';
import { mapV1FieldsToV2Data as mapV1FieldsToV2Data_691f80ce0664e043e4a1986d, buildCustomizePayload as buildCustomizePayload_691f80ce0664e043e4a1986d } from './691f80ce0664e043e4a1986d/mappers';

import { PdfConfig as PdfConfig_69d0c43f5a2b1c0d9e8f7a6b } from './69d0c43f5a2b1c0d9e8f7a6b/PdfConfig';
import { FactsheetPreview as FactsheetPreview_69d0c43f5a2b1c0d9e8f7a6b } from './69d0c43f5a2b1c0d9e8f7a6b/PdfPreview';
import { PdfPreviewDialog as PdfPreviewDialog_69d0c43f5a2b1c0d9e8f7a6b, FactsheetPDF as FactsheetPDF_69d0c43f5a2b1c0d9e8f7a6b } from './69d0c43f5a2b1c0d9e8f7a6b/PdfPreviewDialog';
import { mapV1FieldsToV2Data as mapV1FieldsToV2Data_69d0c43f5a2b1c0d9e8f7a6b, buildCustomizePayload as buildCustomizePayload_69d0c43f5a2b1c0d9e8f7a6b } from './69d0c43f5a2b1c0d9e8f7a6b/mappers';

import { PdfConfig as PdfConfig_69842241581723c403c697fc } from './69842241581723c403c697fc/PdfConfig';
import { FactsheetPreview as FactsheetPreview_69842241581723c403c697fc } from './69842241581723c403c697fc/PdfPreview';
import { PdfPreviewDialog as PdfPreviewDialog_69842241581723c403c697fc, FactsheetPDF as FactsheetPDF_69842241581723c403c697fc } from './69842241581723c403c697fc/PdfPreviewDialog';
import { mapV1FieldsToV2Data as mapV1FieldsToV2Data_69842241581723c403c697fc, buildCustomizePayload as buildCustomizePayload_69842241581723c403c697fc } from './69842241581723c403c697fc/mappers';

import { PdfConfig as PdfConfig_6a56437d260e22f9e9296ede } from './6a56437d260e22f9e9296ede/PdfConfig';
import { FactsheetPreview as FactsheetPreview_6a56437d260e22f9e9296ede } from './6a56437d260e22f9e9296ede/PdfPreview';
import { PdfPreviewDialog as PdfPreviewDialog_6a56437d260e22f9e9296ede, FactsheetPDF as FactsheetPDF_6a56437d260e22f9e9296ede } from './6a56437d260e22f9e9296ede/PdfPreviewDialog';
import { mapV1FieldsToV2Data as mapV1FieldsToV2Data_6a56437d260e22f9e9296ede, buildCustomizePayload as buildCustomizePayload_6a56437d260e22f9e9296ede } from './6a56437d260e22f9e9296ede/mappers';

import { PdfConfig as PdfConfig_pr } from './pr-real-value/PdfConfig';
import { FactsheetPreview as FactsheetPreview_pr } from './pr-real-value/PdfPreview';
import { PdfPreviewDialog as PdfPreviewDialog_pr, FactsheetPDF as FactsheetPDF_pr } from './pr-real-value/PdfPreviewDialog';
import { mapV1FieldsToV2Data as mapV1FieldsToV2Data_pr, buildCustomizePayload as buildCustomizePayload_pr } from './pr-real-value/mappers';
import {
  PR_TEMPLATE_P_DE,
  PR_TEMPLATE_P_EN,
  PR_TEMPLATE_R_DE,
  PR_TEMPLATE_R_EN,
} from './pr-real-value/templateConstants';

export const TEMPLATE_ID_68ef31e18875863b2fa59822 = '68ef31e18875863b2fa59822';
export const TEMPLATE_ID_691f80ce0664e043e4a1986d = '691f80ce0664e043e4a1986d';
export const TEMPLATE_ID_69d0c43f5a2b1c0d9e8f7a6b = '69d0c43f5a2b1c0d9e8f7a6b';
export const TEMPLATE_ID_69842241581723c403c697fc = '69842241581723c403c697fc';
export const TEMPLATE_ID_6995ea9e4c4ced0db3932d1a = '6995ea9e4c4ced0db3932d1a';
export const TEMPLATE_ID_6995ec804c4ced0db3932d1b = '6995ec804c4ced0db3932d1b';
export const TEMPLATE_ID_6995ed834c4ced0db3932d1c = '6995ed834c4ced0db3932d1c';
export const TEMPLATE_ID_6a56437d260e22f9e9296ede = '6a56437d260e22f9e9296ede';
/** Plutos – Longevity Innovation Fund: same components as Active Mining (691f80ce…), own template id / ISIN. */
export const TEMPLATE_ID_6a98f0c8b6c2a1d4e5f60001 = '6a98f0c8b6c2a1d4e5f60001';
/**
 * Further Plutos funds on VP Bank data (rollout 11/2026): one template per share class, same components as Active
 * Mining. Mirror of Plutos/funds/*.json → outputs[].factsheet.templateId and the server registry
 * (src/scripts/plutos-vpbank/registry.ts). Order: T-VEST A, ML Sector Select A, Active Gold Mining A,
 * Finanzmatrix P, Multi Chance I, Multi Chance R.
 */
export const PLUTOS_VPBANK_TEMPLATE_IDS: readonly string[] = [
  '6a98f0c8b6c2a1d4e5f60101',
  '6a98f0c8b6c2a1d4e5f60201',
  '6a98f0c8b6c2a1d4e5f60301',
  '6a98f0c8b6c2a1d4e5f60401',
  '6a98f0c8b6c2a1d4e5f60501',
  '6a98f0c8b6c2a1d4e5f60601',
];
export { PR_TEMPLATE_P_DE, PR_TEMPLATE_P_EN, PR_TEMPLATE_R_DE, PR_TEMPLATE_R_EN };

export interface TemplateComponents {
  PdfConfig: typeof PdfConfig_68ef31e18875863b2fa59822;
  FactsheetPreview: any;
  PdfPreviewDialog: any;
  FactsheetPDF: any;
  mapV1FieldsToV2Data: (fields: any, templateId?: string) => any;
  buildCustomizePayload: (v2Data: any, original: any) => any;
}

const prRealValueTemplateComponents: TemplateComponents = {
  PdfConfig: PdfConfig_pr,
  FactsheetPreview: FactsheetPreview_pr,
  PdfPreviewDialog: PdfPreviewDialog_pr,
  FactsheetPDF: FactsheetPDF_pr,
  mapV1FieldsToV2Data: mapV1FieldsToV2Data_pr,
  buildCustomizePayload: buildCustomizePayload_pr,
};

/** Active Mining components (691f80ce…), shared by the Plutos templates that use the same layout. */
const activeMiningLayoutComponents: TemplateComponents = {
  PdfConfig: PdfConfig_691f80ce0664e043e4a1986d,
  FactsheetPreview: FactsheetPreview_691f80ce0664e043e4a1986d,
  PdfPreviewDialog: PdfPreviewDialog_691f80ce0664e043e4a1986d,
  FactsheetPDF: FactsheetPDF_691f80ce0664e043e4a1986d,
  mapV1FieldsToV2Data: mapV1FieldsToV2Data_691f80ce0664e043e4a1986d,
  buildCustomizePayload: buildCustomizePayload_691f80ce0664e043e4a1986d,
};

const templateRegistry: Record<string, TemplateComponents> = {
  [TEMPLATE_ID_68ef31e18875863b2fa59822]: {
    PdfConfig: PdfConfig_68ef31e18875863b2fa59822,
    FactsheetPreview: FactsheetPreview_68ef31e18875863b2fa59822,
    PdfPreviewDialog: PdfPreviewDialog_68ef31e18875863b2fa59822,
    FactsheetPDF: FactsheetPDF_68ef31e18875863b2fa59822,
    mapV1FieldsToV2Data: mapV1FieldsToV2Data_68ef31e18875863b2fa59822,
    buildCustomizePayload: buildCustomizePayload_68ef31e18875863b2fa59822,
  },
  [TEMPLATE_ID_691f80ce0664e043e4a1986d]: activeMiningLayoutComponents,
  [TEMPLATE_ID_69d0c43f5a2b1c0d9e8f7a6b]: {
    PdfConfig: PdfConfig_69d0c43f5a2b1c0d9e8f7a6b,
    FactsheetPreview: FactsheetPreview_69d0c43f5a2b1c0d9e8f7a6b,
    PdfPreviewDialog: PdfPreviewDialog_69d0c43f5a2b1c0d9e8f7a6b,
    FactsheetPDF: FactsheetPDF_69d0c43f5a2b1c0d9e8f7a6b,
    mapV1FieldsToV2Data: mapV1FieldsToV2Data_69d0c43f5a2b1c0d9e8f7a6b,
    buildCustomizePayload: buildCustomizePayload_69d0c43f5a2b1c0d9e8f7a6b,
  },
  [TEMPLATE_ID_69842241581723c403c697fc]: {
    PdfConfig: PdfConfig_69842241581723c403c697fc,
    FactsheetPreview: FactsheetPreview_69842241581723c403c697fc,
    PdfPreviewDialog: PdfPreviewDialog_69842241581723c403c697fc,
    FactsheetPDF: FactsheetPDF_69842241581723c403c697fc,
    mapV1FieldsToV2Data: mapV1FieldsToV2Data_69842241581723c403c697fc,
    buildCustomizePayload: buildCustomizePayload_69842241581723c403c697fc,
  },
  [TEMPLATE_ID_6995ea9e4c4ced0db3932d1a]: {
    PdfConfig: PdfConfig_69842241581723c403c697fc,
    FactsheetPreview: FactsheetPreview_69842241581723c403c697fc,
    PdfPreviewDialog: PdfPreviewDialog_69842241581723c403c697fc,
    FactsheetPDF: FactsheetPDF_69842241581723c403c697fc,
    mapV1FieldsToV2Data: mapV1FieldsToV2Data_69842241581723c403c697fc,
    buildCustomizePayload: buildCustomizePayload_69842241581723c403c697fc,
  },
  [TEMPLATE_ID_6995ec804c4ced0db3932d1b]: {
    PdfConfig: PdfConfig_69842241581723c403c697fc,
    FactsheetPreview: FactsheetPreview_69842241581723c403c697fc,
    PdfPreviewDialog: PdfPreviewDialog_69842241581723c403c697fc,
    FactsheetPDF: FactsheetPDF_69842241581723c403c697fc,
    mapV1FieldsToV2Data: mapV1FieldsToV2Data_69842241581723c403c697fc,
    buildCustomizePayload: buildCustomizePayload_69842241581723c403c697fc,
  },
  [TEMPLATE_ID_6995ed834c4ced0db3932d1c]: {
    PdfConfig: PdfConfig_69842241581723c403c697fc,
    FactsheetPreview: FactsheetPreview_69842241581723c403c697fc,
    PdfPreviewDialog: PdfPreviewDialog_69842241581723c403c697fc,
    FactsheetPDF: FactsheetPDF_69842241581723c403c697fc,
    mapV1FieldsToV2Data: mapV1FieldsToV2Data_69842241581723c403c697fc,
    buildCustomizePayload: buildCustomizePayload_69842241581723c403c697fc,
  },
  [TEMPLATE_ID_6a56437d260e22f9e9296ede]: {
    PdfConfig: PdfConfig_6a56437d260e22f9e9296ede,
    FactsheetPreview: FactsheetPreview_6a56437d260e22f9e9296ede,
    PdfPreviewDialog: PdfPreviewDialog_6a56437d260e22f9e9296ede,
    FactsheetPDF: FactsheetPDF_6a56437d260e22f9e9296ede,
    mapV1FieldsToV2Data: mapV1FieldsToV2Data_6a56437d260e22f9e9296ede,
    buildCustomizePayload: buildCustomizePayload_6a56437d260e22f9e9296ede,
  },
  [TEMPLATE_ID_6a98f0c8b6c2a1d4e5f60001]: activeMiningLayoutComponents,
  ...Object.fromEntries(PLUTOS_VPBANK_TEMPLATE_IDS.map((id) => [id, activeMiningLayoutComponents])),
  [PR_TEMPLATE_P_DE]: prRealValueTemplateComponents,
  [PR_TEMPLATE_P_EN]: prRealValueTemplateComponents,
  [PR_TEMPLATE_R_DE]: prRealValueTemplateComponents,
  [PR_TEMPLATE_R_EN]: prRealValueTemplateComponents,
};

export function getTemplateComponents(templateId: string | undefined): TemplateComponents | null {
  if (!templateId) return null;
  return templateRegistry[templateId] || null;
}

export const defaultTemplateId = TEMPLATE_ID_68ef31e18875863b2fa59822;
export const defaultTemplate = templateRegistry[defaultTemplateId];
